import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const ReportFilterInput = () => {
  const { filterId = '' } = useParams();
  const decodedId = filterId ? atob(filterId) : filterId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'reportFilter';

  useEffect(() => {
    if (filterId) { setIsEditing(true); fetchDetails(); }
  }, [filterId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['reportFilter'] + id + '/', { headers });
      const d = response.data;
      setFormData({
        ...d,
        report: d.report?.id ?? d.report,
      });
    } catch (error) { console.error('Error fetching Filter details:', error); }
  };

  const fields = [
    {
      name: 'report',
      label: 'Report',
      type: 'async-select',
      required: true,
      endpoint: API_ROUTES.report,
      getOptionLabel: (r) => r.name,
    },
    { name: 'name', label: 'Name', type: 'text', required: true },
    { name: 'filter_type', label: 'Filter Type', type: 'text', required: true },
    { name: 'criteria', label: 'Criteria', type: 'text', required: true } // Mapped to 'criteria'
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Filter' : 'Create Filter'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} cancelPath="/reporting/filter/list" />
    </div>
  );
};

export default ReportFilterInput;